// src/ComingSoon.js
import React from 'react';

const ComingSoon = ({ title = "Coming Soon", message = "This feature is under construction." }) => {
  return (
    <div style={styles.container}>
      <h1 style={styles.title}>🚧 {title}</h1>
      <p style={styles.message}>{message}</p>
    </div>
  );
};

const styles = {
  container: {
    padding: '50px',
    textAlign: 'center',
    fontFamily: 'sans-serif',
  },
  title: {
    fontSize: '2.5rem',
    color: '#444',
  },
  message: {
    fontSize: '1.2rem',
    color: '#666',
  },
};

export default ComingSoon;
